import { useContext } from "react";

import { PropertiesContext } from "./PropertiesContext";

export const useSelectPropertyFromContextById = (propertyId) =>
  useContext(PropertiesContext).properties[propertyId];
